module.exports = __webpack_public_path__ + "img/wep_spear03.d1249eac.png";